<template>
  <div class="g-header-div">
    <div class="g-header">
      <div class="g-header-con">
        <div class="g-header-logo" />
        <p class="g-header-title">易讲-教室直播</p>
        <a-menu
          :defaultSelectedKeys="[getIndex()]"
          :selectedKeys="[getIndex()]"
          :style="{ lineHeight: '50px', width: menuWidth, position: 'absolute', top: 0, left: '230px'}"
          @click="changeSelect"
          mode="horizontal"
          theme="dark"
        >
          <a-menu-item :key="item.index" v-for="item in menuInfo">
            <router-link :to="item.path">
              <span>{{ item.name }}</span>
            </router-link>
          </a-menu-item>
        </a-menu>
        <div class="main-head">
          <a-dropdown placement="bottomRight">
            <a-button
              style="
                height: 50px;
                line-height: 50px;
                border: 0;
                background: 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                cursor: pointer;
                padding: 0;
              "
            >
              <span>
                <a-badge :count="msgCount">
                  <a-avatar :src="avatar" icon="user" />
                </a-badge>
              </span>
              <p class="main-head-name">{{ userName }}</p>
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="gotoUser">
                  <a-icon class="user-edit-icon" type="edit" />修改信息
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <i class="main-head-line">|</i>
          <a-popconfirm
            @cancel="cancel"
            @confirm="confirm"
            cancel-text="取消"
            ok-text="退出"
            title="确认退出当前账号吗?"
          >
            <a class="main-head-quit" style="color: #fff">退出</a>
          </a-popconfirm>
        </div>
      </div>
    </div>
    <router-view ref="container" />
    <users></users>
  </div>
</template>
<script>
import global from "../../utils/Global";
import users from "./users.vue"
var infos = [];
// for (var i = 0; i < global.menuInfo.length; i++) {
//   if (global.menuInfo[i].index < 100) {
//     infos.push(global.menuInfo[i]);
//   }
// }

export default {
  components: {
    users
  },
  data () {
    return {
      screen: null,
      msgCount: 0,
      menuInfo: infos,
      menuIndex: 0,
      mWidth: 0,
      userName: global.userInfo ? global.userInfo.username : null,
      avatar: global.userInfo ? global.userInfo.img_url : null,
    };
  },

  mounted () {
    if (!global.userInfo) {
      this.$router.push("login");
    }
    setInterval(() => {
      if ($("body").hasClass("horizontal-screen")) {
        if (this.screen != "horizontal") {
          this.screen = "horizontal";
          $(".vertical-screen .ant-btn.ant-dropdown-trigger").css({
            height: "30px",
            "line-height": "30px",
          });
        }
      } else {
        if (this.screen != "vertical") {
          this.screen = "vertical";
          $(".vertical-screen .ant-btn.ant-dropdown-trigger").css({
            height: "30px",
            "line-height": "30px",
          });
        }
      }
    }, 300);
  },
  computed: {
    menuWidth: function () {
      return this.mWidth + "px";
    },
  },
  methods: {
    getIndex () {
      var menuIndex = global.getMenuIndex(this.$route.path);
      return menuIndex;
    },
    resize () {
      this.mWidth = window.innerWidth - 440;
      if (this.$refs.container && this.$refs.container.resize) {
        this.$refs.container.resize();
      }
    },
    confirm (e) {
      var that = this;
      // 退出默认域
      QHPass.signOut(function () {
        that.$message.success("已退出登录");
        global.isJumpingToLogin = null;
        global.userInfo = null;
        window.location.reload();
      });
    },
    cancel (e) { },
    changeSelect (e) {
      this.menuIndex = e.key;
    },
    // 显示修改学生信息弹窗
    showUserInfoPanel () {
      this.$store.commit('changeStuInfoShow', true)
    },
    gotoUser () {
      this.getSchoolList()
    },
    getSchoolList () {
      this.axios(global.ajaxAdd.getSchoolList, {})
        .then((d) => {
          this.$store.commit('getStudentInfo', d.data)
          this.showUserInfoPanel()
        })
        .catch((e) => {
          console.log(e)
          this.$message.error(e.data.errmsg)
        });
    },
    axios (url, data) {
      var pubData_ = {
        from: "student",
        qid: global.userInfo.qid,
        reg_time: new Date().getTime(),
      };
      if (this.student_id) {
        pubData_.student_id = this.student_id;
      }
      data = Object.assign(pubData_, data);
      var that = this;
      return new Promise(function (resolve, reject) {
        that.$axios
          .post("/api" + url, data, {
            transformRequest: [
              function (data) {
                let params = "";
                for (let index in data) {
                  params += index + "=" + data[index] + "&";
                }
                return params;
              },
            ],
          })
          .then(function (res) {
            if (res && res.data && res.data.errno == 0) {
              if (resolve) {
                resolve(res.data);
              }
            } else if (res && res.data) {
              reject(res);
              // that.msg(res.data.errmsg, "error");
              switch (res.data.errno) {
                case 400027:
                  break;
                case 39:
                case 700006:
                case 442:
                  //登录信息过期
                  global.isJumpingToLogin = null;
                  global.userInfo = null;
                  window.location.reload();
                  break;
                case 1000001:
                  that.lessons = [];
                  break;
              }
            }
          })
          .catch(function (e) {
            reject(e);
            // that.msg(e.errmsg, "error");
          });
      });
    },
  },
};
</script>

<style>
.ant-menu-dark {
  background: 0;
}
.g-header-div {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.g-header {
  width: 100%;
  height: 50px;
  background: #006bff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.49);
  position: relative;
  z-index: 2;
}

.g-header-con {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
/* .size-big .g-header-con {
  width: 1600px;
}
.size-normal .g-header-con {
  width: 1360px;
}
.size-small .g-header-con {
  width: 1200px;
} */
.horizontal-screen .g-header-div,
.vertical-screen .g-header-div {
  height: 30px;
}
.vertical-screen .g-header,
.horizontal-screen .g-header {
  height: 30px;
  width: 100%;
  min-width: 100%;
}
.vertical-screen .g-header-con,
.horizontal-screen .g-header-con {
  width: 100%;
}
.horizontal-screen .g-header-logo,
.vertical-screen .g-header-logo {
  width: 78px;
  height: 21px;
  margin: 6px 15px 0px 5px;
}
.horizontal-screen .g-header-title,
.vertical-screen .g-header-title {
  font-size: 16px;
  line-height: 34px;
}
.horizontal-screen .main-head,
.vertical-screen .main-head {
  height: 30px;
  right: 0;
}
.horizontal-screen .ant-btn.ant-dropdown-trigger,
.vertical-screen .ant-btn.ant-dropdown-trigger {
  height: 30px;
  line-height: 30px;
}
.horizontal-screen
  .ant-avatar.ant-avatar-circle.ant-avatar-image.ant-avatar-icon,
.vertical-screen
  .ant-avatar.ant-avatar-circle.ant-avatar-image.ant-avatar-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.vertical-screen .main-head-quit,
.horizontal-screen .main-head-quit {
  line-height: 36px;
}
.vertical-screen .main-head-name {
  display: none;
}
.vertical-screen .main-head-line {
  display: none;
}
.main-head {
  width: 220px;
  height: 50px;
  position: absolute;
  right: 20px;
  top: 0;
  z-index: 21;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.main-head-name {
  max-width: 100px;
  color: #fff;
  line-height: 50px;
  height: 50px;
  margin: 0 0 0 10px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.main-head-line {
  margin: 0 14px;
  display: inline-block;
  color: #ddd;
}
.main-head-quit {
  width: 40px;
}
.g-header-logo {
  width: 112px;
  height: 30px;
  background: url(https://p3.ssl.qhimg.com/t014911e2ea1112a172.png) no-repeat;
  background-size: 100% 100%;
  margin: 10px 26px 8px 10px;
  float: left;
}
.g-header-title {
  line-height: 50px;
  font-size: 22px;
  color: #fff;
}
.user-edit-icon {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main/header.vue